export default __webpack_public_path__ + "static/statsd_metrics_01-1eae9ec2199f9fc610cd7ad5bd49f49c.png";